import { render, staticRenderFns } from "./SafetyCheckPartner444Index.vue?vue&type=template&id=c8280b3e&scoped=true&"
import script from "./SafetyCheckPartner444Index.vue?vue&type=script&lang=js&"
export * from "./SafetyCheckPartner444Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8280b3e",
  null
  
)

export default component.exports